<section class="pe-accordion" [ngClass]="customClasses">
	<ng-content></ng-content>
</section>
